import React from 'react';
import Row  from '../common/Row';
import { Link } from 'react-router-dom';
const HeaderButton =(props)=>{
    const {title,Icon,className,url}= props;
 return (
        <Link className="rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" to={url}>
      
       <Row className= {className} >
             <Icon/>
             <p className="ml-2 text-sm font-medium text-slate-700 transition hover:text-indigo-600">
               {title}
             </p>
            </Row>
            </Link>
 );
}

export default HeaderButton;
